export default {
  tag: "Socios Aprobados",
  title1: "Cocinas",
  title2: "Comisaría",
  subtitle:
    "Socios de comisaría confiables en todo el Condado de Orange para camiones de catering y operaciones de comida preenvasada.",
  cateringTrucks: "Camiones de Catering",
  prepackagedTrucks: "Camiones de Comida Preenvasada",
  needHelp: "¿Necesitas Ayuda para Elegir?",
  needHelpText:
    "¿No estás seguro de qué comisaría es la adecuada para tu operación? Podemos ayudarte a encontrar la mejor opción según tu ubicación y tipo de camión.",
  bookSession: "Reservar una Sesión",
};